import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApplication } from '../interfaces/application';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private rootUrl: string = "/api/applications";

  constructor(private httpClient: HttpClient) { }

  public getSiteAdminApplications(username: string): Observable<IApplication[]> {
    const url = this.rootUrl + "/site-admin?username=" + username;
    return this.httpClient.get<IApplication[]>(url);
  }

  public getAgencyAdminApplications(username: string): Observable<IApplication[]> {
    const url = this.rootUrl + "/agency-admin?username=" + username;
    return this.httpClient.get<IApplication[]>(url);
  }
}
